import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Home = () => {
  return (
    <div style={{background: '#ffffff'}}>
      <Helmet>
        <title>Aramco Leads Pro - CRM & Lead Management Platform</title>
        <meta name="description" content="Professional CRM and lead management platform with integrated customer communication tools. Track leads, manage relationships, and send automated notifications." />
        <meta name="keywords" content="CRM, lead management, customer relationship management, lead tracking, customer notifications" />
      </Helmet>

      {/* Hero Section */}
      <section style={{
        background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 50%, #60a5fa 100%)',
        padding: '8rem 2rem 6rem',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, opacity: 0.1}}>
          <div style={{position: 'absolute', top: '10%', left: '10%', width: '300px', height: '300px', background: '#fff', borderRadius: '50%', filter: 'blur(100px)'}}></div>
          <div style={{position: 'absolute', bottom: '10%', right: '10%', width: '400px', height: '400px', background: '#fbbf24', borderRadius: '50%', filter: 'blur(120px)'}}></div>
        </div>
        
        <div style={{maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1}}>
          <div style={{textAlign: 'center', maxWidth: '800px', margin: '0 auto'}}>
            <div style={{display: 'inline-flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem 1rem', background: 'rgba(255,255,255,0.2)', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '50px', marginBottom: '2rem', fontSize: '0.875rem', color: '#fff'}}>
              <span style={{width: '8px', height: '8px', background: '#fbbf24', borderRadius: '50%'}}></span>
              A2P 10DLC Compliant & TCPA Certified
            </div>
            
            <h1 style={{fontSize: '4rem', fontWeight: '800', lineHeight: '1.1', marginBottom: '1.5rem', color: '#ffffff', fontFamily: 'Inter'}}>
              Manage Your Leads
              <br />
              <span style={{color: '#fbbf24'}}>Grow Your Business</span>
            </h1>
            
            <p style={{fontSize: '1.25rem', color: 'rgba(255,255,255,0.9)', marginBottom: '2.5rem', lineHeight: '1.8'}}>
              All-in-one CRM platform to track leads, manage customer relationships, and send automated appointment reminders and follow-ups.
            </p>
            
            <div style={{display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap'}}>
              <Link to="/contact" style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '1rem 2rem',
                background: '#fbbf24',
                color: '#1f2937',
                textDecoration: 'none',
                borderRadius: '12px',
                fontWeight: '700',
                fontSize: '1.1rem',
                transition: 'all 0.3s ease',
                boxShadow: '0 8px 24px rgba(251, 191, 36, 0.4)'
              }}>
                Start Free Trial
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </Link>
              
              <Link to="/features" style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '1rem 2rem',
                background: 'rgba(255,255,255,0.2)',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '12px',
                fontWeight: '700',
                fontSize: '1.1rem',
                border: '2px solid rgba(255,255,255,0.3)',
                transition: 'all 0.3s ease'
              }}>
                View Features
              </Link>
            </div>
            
            {/* Stats */}
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '2rem', marginTop: '4rem', paddingTop: '2rem', borderTop: '1px solid rgba(255,255,255,0.2)'}}>
              <div>
                <div style={{fontSize: '2.5rem', fontWeight: '800', color: '#fbbf24', marginBottom: '0.25rem'}}>99.9%</div>
                <div style={{fontSize: '0.875rem', color: 'rgba(255,255,255,0.8)'}}>Message Delivery</div>
              </div>
              <div>
                <div style={{fontSize: '2.5rem', fontWeight: '800', color: '#fbbf24', marginBottom: '0.25rem'}}>24/7</div>
                <div style={{fontSize: '0.875rem', color: 'rgba(255,255,255,0.8)'}}>Support</div>
              </div>
              <div>
                <div style={{fontSize: '2.5rem', fontWeight: '800', color: '#fbbf24', marginBottom: '0.25rem'}}>100%</div>
                <div style={{fontSize: '0.875rem', color: 'rgba(255,255,255,0.8)'}}>TCPA Compliant</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section style={{padding: '6rem 2rem', background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          
          <div style={{textAlign: 'center', marginBottom: '4rem'}}>
            <div style={{display: 'inline-flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem 1.25rem', background: 'linear-gradient(135deg, #dbeafe 0%, #e0e7ff 100%)', color: '#1e40af', borderRadius: '50px', fontSize: '0.875rem', fontWeight: '700', marginBottom: '1.5rem', border: '1px solid #bfdbfe'}}>
              <svg width="16" height="16" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
              </svg>
              POWERFUL FEATURES
            </div>
            <h2 style={{fontSize: '3.5rem', fontWeight: '900', marginBottom: '1.5rem', fontFamily: 'Inter', color: '#0f172a', lineHeight: '1.1'}}>
              Everything You Need to<br />
              <span style={{background: 'linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text'}}>Manage & Convert Leads</span>
            </h2>
            <p style={{fontSize: '1.25rem', color: '#64748b', maxWidth: '700px', margin: '0 auto', lineHeight: '1.8'}}>
              Complete CRM solution with integrated customer communication and advanced analytics
            </p>
          </div>

          {/* Feature Cards with Images */}
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '2rem', marginBottom: '4rem'}}>
            {[
              {
                icon: '📊',
                title: 'Lead Tracking & Management',
                desc: 'Track and manage all your leads in one centralized dashboard with real-time updates and intelligent scoring',
                color: '#3b82f6',
                image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=250&fit=crop'
              },
              {
                icon: '👥',
                title: 'Contact Management',
                desc: 'Store and organize customer information, interaction history, preferences, and communication logs',
                color: '#8b5cf6',
                image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=250&fit=crop'
              },
              {
                icon: '📅',
                title: 'Automated Reminders',
                desc: 'Send automated SMS and email reminders for appointments, follow-ups, and important deadlines',
                color: '#06b6d4',
                image: 'https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=400&h=250&fit=crop'
              },
              {
                icon: '📱',
                title: 'Customer Notifications',
                desc: 'Send order updates, service alerts, account notifications, and promotional messages to customers',
                color: '#10b981',
                image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=400&h=250&fit=crop'
              },
              {
                icon: '📈',
                title: 'Analytics & Insights',
                desc: 'Track lead conversion rates, customer engagement metrics, and communication effectiveness in real-time',
                color: '#f59e0b',
                image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=250&fit=crop&sat=-100'
              },
              {
                icon: '🔗',
                title: 'Seamless Integrations',
                desc: 'Connect with your existing tools and workflows via API. Integrate with popular platforms effortlessly',
                color: '#ec4899',
                image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=400&h=250&fit=crop'
              }
            ].map((feature, index) => (
              <div 
                key={index} 
                style={{
                  background: 'white',
                  borderRadius: '20px',
                  overflow: 'hidden',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
                  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                  cursor: 'pointer',
                  border: '1px solid #e2e8f0'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-12px)';
                  e.currentTarget.style.boxShadow = `0 20px 40px ${feature.color}20`;
                  e.currentTarget.style.borderColor = feature.color;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.05)';
                  e.currentTarget.style.borderColor = '#e2e8f0';
                }}
              >
                <div style={{position: 'relative', height: '200px', overflow: 'hidden'}}>
                  <img 
                    src={feature.image} 
                    alt={feature.title}
                    style={{width: '100%', height: '100%', objectFit: 'cover'}}
                  />
                  <div style={{position: 'absolute', top: '1rem', left: '1rem', width: '60px', height: '60px', background: 'white', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '2rem', boxShadow: '0 4px 12px rgba(0,0,0,0.1)'}}>
                    {feature.icon}
                  </div>
                </div>
                <div style={{padding: '2rem'}}>
                  <h3 style={{fontSize: '1.5rem', fontWeight: '700', marginBottom: '0.75rem', color: '#0f172a'}}>{feature.title}</h3>
                  <p style={{color: '#64748b', lineHeight: '1.7', fontSize: '0.95rem'}}>{feature.desc}</p>
                  <div style={{marginTop: '1.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem', color: feature.color, fontWeight: '600', fontSize: '0.95rem'}}>
                    Learn more
                    <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{padding: '6rem 2rem', background: 'linear-gradient(135deg, #1f2937 0%, #111827 100%)', position: 'relative', overflow: 'hidden'}}>
        <div style={{position: 'absolute', top: '0', right: '0', width: '500px', height: '500px', background: 'radial-gradient(circle, rgba(30, 64, 175, 0.2) 0%, transparent 70%)', borderRadius: '50%'}}></div>
        <div style={{maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1}}>
          <div style={{maxWidth: '800px', margin: '0 auto', textAlign: 'center'}}>
            <h2 style={{fontSize: '3rem', fontWeight: '800', color: 'white', marginBottom: '1.5rem', fontFamily: 'Inter'}}>
              Ready to Streamline Your Lead Management?
            </h2>
            <p style={{fontSize: '1.25rem', color: 'rgba(255,255,255,0.8)', marginBottom: '3rem', lineHeight: '1.8'}}>
              Join businesses using Aramco Leads Pro to manage customer relationships and automate communications
            </p>
            <Link to="/contact" style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.75rem',
              padding: '1.25rem 3rem',
              background: '#fbbf24',
              color: '#1f2937',
              textDecoration: 'none',
              borderRadius: '12px',
              fontWeight: '700',
              fontSize: '1.25rem',
              boxShadow: '0 8px 32px rgba(251, 191, 36, 0.4)',
              transition: 'all 0.3s ease'
            }}>
              Get Started Free
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
